<div class="list-rat-ch custom-rating">
  <div class="rating-value custom-rating-standard">{{rating}}</div>
  <div *ngFor="let i of arrayOne(intValue); let j = index;"
       class="custom-rating-standard custom-rating-item full-star"></div>
  <div class="custom-rating-standard custom-rating-item half-full half-full-img" *ngIf="half"></div>
  <div *ngFor="let i of arrayOne(emptyStars); let k = index;" class="custom-rating-standard custom-rating-item"></div>
</div>
